import SubscribedEmailTable from './SubscribedEmailTable'

const NewLetterPage = () => {
  return <SubscribedEmailTable />
}

export default NewLetterPage
